import {
  CellEditingStoppedEvent,
  CellValueChangedEvent,
  GridApi,
} from "ag-grid-community";
import { message } from "antd";

export const applyFlexToLastColumn = (api: GridApi) => {
  const allCols = api.getColumns();
  if (!allCols) return;

  allCols.forEach((col) => {
    api.applyColumnState({
      state: [{ colId: col.getColId(), flex: null }],
    });
  });

  const rowGroupColIds = api.getRowGroupColumns().map((col) => col.getColId());

  const visibleCols = allCols.filter(
    (col) => col.isVisible() && !rowGroupColIds.includes(col.getColId()),
  );

  const lastCol = visibleCols[visibleCols.length - 1];
  if (lastCol) {
    api.applyColumnState({
      state: [{ colId: lastCol.getColId(), flex: 1 }],
    });
  }
};

export const statusBar = {
  statusPanels: [
    { statusPanel: "agTotalAndFilteredRowCountComponent" },
    { statusPanel: "agTotalRowCountComponent" },
    { statusPanel: "agFilteredRowCountComponent" },
    { statusPanel: "agSelectedRowCountComponent" },
    { statusPanel: "agAggregationComponent" },
  ],
};
export const VALIDATION_ERRORS_KEY = "__validationErrors";

export const isEmptyCellValue = (value: unknown): boolean => {
  if (value == null) return true;

  if (typeof value === "string") {
    return value.trim() === "";
  }

  return false;
};

export const handleCellValidation = (
  params: CellValueChangedEvent<any> | CellEditingStoppedEvent<any>,
): boolean => {
  const field = params.colDef.field;

  if (!field || !params.data) return true;

  const isRequired = Boolean(
    (params.colDef as any).required || (params.colDef as any).isMandatory,
  );

  const existingErrors = params.data[VALIDATION_ERRORS_KEY] || {};

  // If NOT required → remove error if exists
  if (!isRequired) {
    if (existingErrors[field]) {
      delete existingErrors[field];
      params.data[VALIDATION_ERRORS_KEY] = existingErrors;

      params.api.refreshCells({
        rowNodes: [params.node],
        columns: [field],
        force: true,
      });
    }
    return true;
  }

  const hasError = isEmptyCellValue(params.data[field]);
  const hadError = Boolean(existingErrors[field]);

  if (hasError) {
    existingErrors[field] = true;
    params.data[VALIDATION_ERRORS_KEY] = existingErrors;

    if (!hadError) {
      const label = params.colDef.headerName || field;
      message.error(`${label} is required`);
    }
  } else if (hadError) {
    delete existingErrors[field];
    params.data[VALIDATION_ERRORS_KEY] = existingErrors;
  }

  // Refresh cell UI
  params.api.refreshCells({
    rowNodes: [params.node],
    columns: [field],
    force: true,
  });

  return !hasError;
};

// formatter
export function currencyFormatter(
  value: any,
  sign: string = "",
  wrapNegative: boolean = false,
): string {
  if (value == null || value === "" || isNaN(Number(value))) return "";

  const num = Number(value);
  const absValue = Math.abs(num).toFixed(0);

  const formatted = absValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  if (num < 0 && wrapNegative) {
    return `(${sign}${formatted})`;
  }

  return `${sign}${formatted}`;
}

export interface TemplateJsonResponse {
  jsonString: string;
  pageCount: number;
  totalRowCount: number;
}